import axios from 'axios'
import React, { useState, useEffect } from 'react'
import validator from "validator"
import { Spinner } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import HideShowToggle from '../../components/HideShowToggle/HideShowToggle'
import ForgotPassGetOTPModal from '../../components/Modals/ForgotPass/ForgotPassGetOTPModal'
import {
  GetAdminProfileUrl,
  LogInUrl,
  StoreLogInUrl,
  GetInfoForOwner,
} from '../../constants/api.constants'
import { useAuth } from '../../Providers/AuthProvider'
import Toast from '../../utils/Toast/Toast'
import './Login.scss'

const Login = () => {
  const [passVisibility, setPassVisibility] = useState(false)
  let location = useLocation()
  let { from } = location.state || { from: { pathname: '/' } }
  let history = useHistory()
  const auth = useAuth()
  const [loginAs, setLoginAs] = useState('admin')
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  const [spin, setSpin] = useState(false)


  const [authValue, setAuthValue] = useState({
    email: '',
    password: '',
  })

  useEffect(() => {
    if (localStorage.getItem("menu_token")) {
      localStorage.setItem("default_path", "/")
    } else if (localStorage.getItem("store_token")) {
      localStorage.setItem("default_path", "/store")
    } else {
      localStorage.setItem("default_path", "/")
    }
  }, [])
  const handleSubmit = async (e) => {
    e.preventDefault()
    const emailDomain = authValue.email.split('.')[1].toLowerCase();
    if (authValue.email === '') {
      Toast('err', 'Please enter your email')
      return
    }
    if (!validator.isEmail(authValue.email)) {
      Toast('err', 'Please enter a valid email');
      return;
    }



    if (authValue.password === '') {
      Toast('err', 'Please enter your password')
      return
    }

    setSpin(true)
    let url = LogInUrl
    if (loginAs === 'manager') {
      url = StoreLogInUrl
    }
    try {
      const response = await axios.post(url, {
        email: authValue.email.toLowerCase(),
        password: authValue.password,
      })
      const token = response.data.menuboard.token

      if (response.status === 200) {

        Toast('success', 'Successfully Logged In!')
        if (response.data.data == true) {
          history.push('/profile')
        }
        if (loginAs === 'admin') {

          localStorage.setItem('menu_token', token)
          localStorage.setItem('Role', response.data.menuboard.admin.effective_role)

          localStorage.setItem('user_role', 'ADMIN')
          localStorage.setItem('default_path', '/')
          getAdminInfo(token)
        } else {
          localStorage.setItem('Role', response.data.menuboard.admin.effective_role)

          localStorage.setItem('default_path', '/store')
          localStorage.setItem('store_token', token)
          localStorage.setItem(
            'store_info',
            JSON.stringify(response?.data?.menuboard?.store)
          )
          localStorage.setItem('user_role', 'MANAGER')
          getStoreManagerInfo(token);
          setSpin(false)

        }
      } else
        throw new Error(
          response?.data?.msg || ' Something went wrong! Try again later.'
        )
    } catch (error) {
      setSpin(false)

      Toast(
        'err',
        error.response?.data?.msg || 'Something went wrong! Try again later.'
      )
    }
  }
  const getStoreManagerInfo = async (token) => {
    try {
      const response = await axios.get(GetInfoForOwner, {
        headers: {
          menuboard: token,
        },
      })
      if (response.status == 200) {
        auth.setUser(response.data.data[0])
        // history.replace(from)
      }
    } catch (err) {
      Toast('err', err.response?.data?.msg)
    }
  }



  const getAdminInfo = async (token) => {
    try {
      const response = await axios.get(GetAdminProfileUrl, {
        headers: {
          menuboard: token,
        },
      })
      if (response.status === 200) {
        auth.setUser(response.data.data)
        history.replace(from)
        setSpin(false)
      } else throw new Error(response?.data?.msg)
    } catch (error) {
      setSpin(false)
      Toast('err', error.response?.data?.msg)
    }
  }

  const [forgotPassModal, setForgotPassModal] = useState(false)

  return (
    <div className='mx-5 login-card  '>
      <h2 className='text-center fw-bold'>
        Login {loginAs === 'admin' ? 'As Admin' : 'In Store'}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className='plain-input mt-3 '>
          <label for=''> {loginAs === 'admin' ? 'User' : 'Store'} Email</label>
          <br />
          <input
            type='text'
            placeholder='Enter your email'
            onChange={(e) =>
              setAuthValue({ ...authValue, email: e.target.value })
            }
            value={authValue.email}
            />
        </div>
        <div className='plain-input mt-3 '>
          <label for=''>
            {loginAs === 'admin' ? 'User' : 'Store'} Password
          </label>
          <br />
          <div className=''>
            <input
              type={passVisibility ? 'text' : 'password'}
              placeholder='Enter your password'
              onChange={(e) =>
                setAuthValue({ ...authValue, password: e.target.value })
              }
              value={authValue.password}
              />
            <HideShowToggle
              passVisibility={passVisibility}
              setPassVisibility={() => setPassVisibility(!passVisibility)}
            />
          </div>
        </div>

        <button
          className=' primary-btn w-100 my-4 d-flex justify-content-center align-items-center'
          type='submit'
        >
          LOGIN{' '}
          <Spinner
            animation='border'
            size='sm'
            className={spin ? 'd-block ms-2' : 'd-none ms-2'}
          />
        </button>
      </form>

      <p
        className=' text-center mt-2 '
        style={{
          color: 'var(--primary_color)',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={() => setLoginAs(loginAs === 'admin' ? 'manager' : 'admin')}
      >
        Login {loginAs === 'admin' ? 'In Store' : 'As Admin'}
      </p>
      {loginAs === 'admin' && (
        <p
          className=' text-center mt-2'
          style={{
            color: 'var(--primary_color)',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={() => setForgotPassModal(true)}
        >
          Forgot password?
        </p>
      )}
      <ForgotPassGetOTPModal
        show={forgotPassModal}
        handleClose={() => setForgotPassModal()}
      />
    </div>
  )
}

export default Login
